import * as yup from 'yup';

export const ExpenseCodeValidationSchema = yup.object({
  name: yup.string().required('Expense Code is a required field').min(1)
});

export type ExpenseCodeFormValues = yup.InferType<
  typeof ExpenseCodeValidationSchema
>;
